import React from 'react';
import './ComponentsCss/BottomBar.css';
// dark img
import homeImg from '../imgs/bottombar/home.png';
import tableImg from '../imgs/bottombar/table.png';
import createIdImg from '../imgs/bottombar/createid.png';
import supportImg from '../imgs/bottombar/support.png';
import addChannelImg from '../imgs/bottombar/add.png';
import monthlyImg from '../imgs/bottombar/monthly.png';
import lawyersImgs from '../imgs/bottombar/lawyers.png';
// light img 
import homeImgli from '../imgs/bottombar/homeli.png';
import tableImgli from '../imgs/bottombar/tableli.png';
import createIdImgli from '../imgs/bottombar/createidli.png';
import supportImgli from '../imgs/bottombar/supportli.png';
import addChannelImgli from '../imgs/bottombar/addli.png';
// gr img
import homeImggr from '../imgs/bottombar/homegr.png';
import tableImggr from '../imgs/bottombar/tablegr.png';
import createIdImggr from '../imgs/bottombar/createidgr.png';
import supportImggr from '../imgs/bottombar/supportgr.png';
import addChannelImggr from '../imgs/bottombar/addgr.png';
import { useNavigate } from 'react-router-dom';
const BottomBar = ({ ViewIdxCallBack }) => {

    //  ModalDataCallBack("SOME BLOB DATA ");
    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    function onClickViewIdx(idx) {
        ViewIdxCallBack(idx);
    }
    const navigate = useNavigate(); 
    return (
        <div className='BottomBarFrame'>
            <div className='BottomBarFrameContents'>
                <div className='BottomBarIcon' onClick={() => { navigate('/'); }}>
                    <img src={homeImg} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'> 홈 </div>
                </div>
                <div className='BottomBarIcon' onClick={() => { navigate('/case'); }}>
                    <img src={tableImg} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'>  사건 게시판  </div>
                </div>
                <div className='BottomBarIcon' onClick={() => { navigate('/profile'); }}>
                    <img src={createIdImg} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'> 프로필 </div>
                </div>
                <div className='BottomBarIcon' onClick={() => openInNewTab("https://www.ihappynanum.com/Nanum/B/IMMM3QZ6I4")}>
                    <img src={supportImg} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'> 후원 </div>
                </div>
                <div className='BottomBarIcon' onClick={() => { navigate('/lawyers'); }}>
                    <img src={lawyersImgs} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'>  전문 회원 </div>
                </div>
                <div className='BottomBarIcon' onClick={() => { navigate('/ms'); }}>
                    <img src={monthlyImg} className='BottomBarIconImg' />
                    <div className='BottomBarIconText'>  월간 선진</div>
                </div>
       
            </div>

        </div>
    )
}

export default BottomBar